/**
 * An invisible box over the active misspelled word, so the Spell Check popover can open under it.
 *
 * The squiggles are drawn only while Show underlines is on, but the popover must open at the word
 * either way, so the word is marked here on its own. It takes no part in painting or pointer events:
 * the popover reads its position from the DOM (`findSpellWordElement`). A word that wraps is marked
 * on the line it starts on, which is where the popover opens.
 */
export function SpellWordAnchor({
  rect,
  range,
}: {
  rect: { x: number; y: number; width: number; height: number }
  /** The word's `[start, end)` in the frame's whole text, as `start-end`. */
  range: string
}) {
  return (
    <div
      data-spell-anchor={range}
      aria-hidden="true"
      className="pointer-events-none invisible absolute"
      style={{ left: rect.x, top: rect.y, width: rect.width, height: rect.height }}
    />
  )
}
